import React, { useContext, useMemo, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';
import RoutesList from './Routes';
import RoutesEnum from './enums/RoutesEnum';
import GlobalSearch from '../pages/__Common/GlobalSearch/GlobalSearch';
import { iPublication, Publication } from './models/Publication';
import Share from '../components/Share/Share';
import { GlobalContext } from '../GlobalContext';
import Library from '../pages/Library/Library';

class SharePopupContextData {
    isOpened: boolean = false;
    open: (sharedItem: iPublication) => void = () => null;
    close: () => void = () => null;
}

export const SharePopupContext: React.Context<SharePopupContextData> = React.createContext(new SharePopupContextData());

export default function Router() {
    const { selectedCountryId } = useContext(GlobalContext);
    const [isSharePopupOpened, setIsSharePopupOpened] = useState(false);
    const [sharedItem, setSharedItem] = useState<iPublication>(new Publication());

    const openSharePopup = (sharedItem: iPublication) => {
        setIsSharePopupOpened(true);
        setSharedItem(sharedItem);
    };

    const closeSharePopup = () => {
        setIsSharePopupOpened(false);
    };

    const routes = useMemo(
        () => RoutesList.filter((i) => !i.disabledForCountries?.includes(selectedCountryId)),
        [selectedCountryId]
    );

    return (
        <SharePopupContext.Provider
            value={{
                isOpened: isSharePopupOpened,
                open: openSharePopup,
                close: closeSharePopup
            }}
        >
            <NuqsAdapter>
                <Routes>
                    <Route index element={<Library />} />
                    {routes.map((route) => (
                        <Route key={route.path} path={route.path} element={<route.Component />} />
                    ))}
                    <Route path="/contentWatch" element={<Navigate to={RoutesEnum.Alerts} replace />} />
                    <Route path="*" element={<Navigate to={RoutesEnum.Home} replace />} />
                </Routes>
                <GlobalSearch />
            </NuqsAdapter>
            <Share isOpened={isSharePopupOpened} sharedItem={sharedItem} close={closeSharePopup} showPreview />
        </SharePopupContext.Provider>
    );
}
